export default __webpack_public_path__ + "static/media/Standard.9300b946.svg";